import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import KeplerGl from 'kepler.gl'
import { AutoSizer } from 'react-virtualized'
import { resetMapConfig, updateMap } from 'kepler.gl/actions'
import { fetchHarrisCounty } from '../actions/fetchActions'
import { Box } from '@mui/material'
import { toggleSidePanel, toggleModal } from 'kepler.gl/actions'

const Map = ({ variable, token, onPolygonDrawn, phase }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(resetMapConfig())
    // Pass the phase flag along with variable and token
    dispatch(fetchHarrisCounty({ variable, token, phase }))

    dispatch(toggleModal(null))
    dispatch(toggleSidePanel(null))
    // Update map to default Houston coordinates
    dispatch(
      updateMap({
        latitude: 29.8,
        longitude: -95.5,
        zoom: 10,
        pitch: 0,
        bearing: 0,
      })
    )
  }, [dispatch, variable, token, phase])

  const mapState = useSelector((state) => state.keplerGl?.flood_zones || {})

  const convertToWKT = (coordinates) => {
    if (!coordinates || !coordinates.length) return null
    const ring = coordinates[0]
    let wktCoords = ring.map((point) => `${point[0]} ${point[1]}`).join(', ')
    if (
      ring[0][0] !== ring[ring.length - 1][0] ||
      ring[0][1] !== ring[ring.length - 1][1]
    ) {
      wktCoords += `, ${ring[0][0]} ${ring[0][1]}`
    }
    return `POLYGON((${wktCoords}))`
  }

  useEffect(() => {
    if (mapState.visState?.editor?.features) {
      const drawnLayers = mapState.visState.editor.features || []
      if (drawnLayers.length > 0) {
        drawnLayers.forEach((feature) => {
          if (feature.geometry.type === 'Polygon') {
            const wktPolygon = convertToWKT(feature.geometry.coordinates)
            if (onPolygonDrawn) onPolygonDrawn(wktPolygon)
          }
        })
      } else {
        if (onPolygonDrawn) onPolygonDrawn(null)
      }
    }
  }, [mapState.visState?.editor?.features, onPolygonDrawn])

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
      }}
    >
      <AutoSizer>
        {({ height, width }) => (
          <KeplerGl
            id="flood_zones"
            width={width}
            height={height}
            mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_KEY}
            theme="base"
            initialViewState={{
              latitude: 29.7604,
              longitude: -95.3698,
              zoom: 6,
              pitch: 0,
              bearing: 0,
            }}
          />
        )}
      </AutoSizer>
    </Box>
  )
}

export default Map
